import { render, staticRenderFns } from "./kalemvize.vue?vue&type=template&id=8f9dcfb2&"
import script from "./kalemvize.vue?vue&type=script&lang=js&"
export * from "./kalemvize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports